import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import './Panel.css';
import {SideBar} from "../SideBar/SideBar.js";
import { Navbar } from '../Navbar/Navbar.js';

const CTAPanel = () => {
  const [ctaContent, setCtaContent] = useState(null);
  const [formData, setFormData] = useState({
    CTAbg: null,
    ctaTitle: '',
    ctaSubtitle: '',
    phoneNumber: '',
  });
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    fetchCTAContent();
  }, []);

  const fetchCTAContent = async () => {
    try {
      const response = await axiosInstance.get('/cta/content');
      if (response.data.length > 0) {
        setCtaContent(response.data[0]);
      }
    } catch (error) {
      console.error('Error fetching CTA content:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  const handleEdit = () => {
    if (ctaContent) {
      const { ctaTitle, ctaSubtitle, phoneNumber } = ctaContent;
      setFormData({
        CTAbg: null,
        ctaTitle,
        ctaSubtitle,
        phoneNumber,
      });
      setEditing(true);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('ctaTitle', formData.ctaTitle);
      formDataToSend.append('ctaSubtitle', formData.ctaSubtitle);
      formDataToSend.append('phoneNumber', formData.phoneNumber);
      if (formData.CTAbg) {
        formDataToSend.append('CTAbg', formData.CTAbg);
      }

      const response = await axiosInstance.put(`/cta/${ctaContent._id}`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        fetchCTAContent();
        setFormData({ CTAbg: null, ctaTitle: '', ctaSubtitle: '', phoneNumber: '' });
        setEditing(false);
      } else {
        console.error('Update failed:', response.statusText);
      }
    } catch (error) {
      console.error('Update error:', error);
    }
  };

  return (
    <>
    <div className="flex">
    <SideBar />
   
    
      <div className="flex-1 h-screen p-6 overflow-auto bg-gray-100">
        <div className="max-w-3xl mx-auto panel-container">
        <div className="panel-form bg-white p-8 rounded-lg shadow-xl">
          <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">CTA Panel</h2>
          <form className="space-y-6" onSubmit={handleUpdate}>
            <div>
              <label htmlFor="CTAbg">Background Image:</label>
              <input               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="file" name="CTAbg" onChange={handleFileChange} accept="image/*" />
            </div>
            <div>
              <label htmlFor="ctaTitle">CTA Title:</label>
              <input               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="ctaTitle" value={formData.ctaTitle} onChange={handleChange} placeholder="CTA Title" required />
            </div>
            <div>
              <label htmlFor="ctaSubtitle">CTA Subtitle:</label>
              <input                className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="ctaSubtitle" value={formData.ctaSubtitle} onChange={handleChange} placeholder="CTA Subtitle" required />
            </div>
            <div>
              <label htmlFor="phoneNumber">Phone Number:</label>
              <input                className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="Phone Number" required />
            </div>
            <button                  className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 type="submit">Update</button>
            {editing && <button                  className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 type="button" onClick={() => setEditing(false)}>Cancel</button>}
          </form>
          {ctaContent && !editing && (
            <div>
              <h3>{ctaContent.ctaTitle}</h3>
              <p>{ctaContent.ctaSubtitle}</p>
              <p>Phone Number: {ctaContent.phoneNumber}</p>
              <button   className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
               onClick={handleEdit}>Edit</button>
            </div>
          )}
        </div>
      </div>
    </div>
    </div>
    
    </>
  );
};

export default CTAPanel;
